import { createAsyncThunk, createSlice } from "@reduxjs/toolkit"
import axiosInstance from "../../axios/axiosInstance";

const initialState = {
    yukKaydiRaporList: [],

    ortalamaAracTedarikRapor: [],

    arsivYukGerekceRaporList: [],

    loadingDurationReport: [],
    unloadingDurationReport: [],

    longestLoadReport: [],
    longestUnloadReport: [],
    longestLoadReportCount: null,
    longestUnloadReportCount: null,
    isLoadingGet:"",
    isErrorGet: "",



    shipmentReportExcelDownloaded: false,
isLoadingShipmentReportExcel: false,
isErrorShipmentReportExcel: ""
}
//! yük kayıt raporu
export const getLoadRegistrationReport = createAsyncThunk("report/getLoadRegistrationReport", async ({companyId = "", yearSelection = 2024}, thunkApi) => {
    try{
        const {data} = await axiosInstance.get(`/reports/LoadRegistrationReport?companyId=${companyId}&&yearSelection=${yearSelection}`)
        
        return data.monthlyReportData
    }catch(error){
        return thunkApi.rejectWithValue(error)
    }
})
//! ortalama araç tedarik süresi raporu
export const getAverageVehicleSupplyTimeReport = createAsyncThunk("report/getAverageVehicleSupplyTimeReport", async (companyId , thunkApi) => {
    try{
        const {data} = await axiosInstance.get(`/reports/GetAverageVehicleSupplyTimeReport?companyId=${companyId}`)
        
        return {monthlyVehicleSupplies: data.monthlyVehicleSupplies.$values, totalYearlyVehicleSupplyDuration: data?.totalYearlyVehicleSupplyDuration}
    }catch(error){
        return thunkApi.rejectWithValue(error)
    }
})
//! arşiv yük kayıt ve gerekçe raporu
export const getArchivedLoadRecordsAndReasonReport = createAsyncThunk("report/getArchivedLoadRecordsAndReasonReport", async (companyId , thunkApi) => {
    try{
        const {data} = await axiosInstance.get(`/reports/GetArchivedLoadRecordsAndReasonReport?companyId=${companyId}`)
        
        return {...data, monthlyLoadingDurations: data?.monthlyLoadingDurations?.$values, yearlyLoadingDuration: data?.yearlyLoadingDuration?.$values}
    }catch(error){
        return thunkApi.rejectWithValue(error)
    }
})
//! yükleme süresi raporu
export const getLoadingDurationReport = createAsyncThunk("report/getLoadingDurationReport", async (companyId , thunkApi) => {
    try{
        const {data} = await axiosInstance.get(`/Reports/GetLoadingDurationReport?companyId=${companyId}`)
        
        return data
    }catch(error){
        return thunkApi.rejectWithValue(error)
    }
})
//! boşaltma süresi raporu
export const getUnloadingDurationReport = createAsyncThunk("report/getUnloadingDurationReport", async (companyId , thunkApi) => {
    try{
        const {data} = await axiosInstance.get(`/Reports/GetUnloadingDurationReport?companyId=${companyId}`)
        
        return data
    }catch(error){
        return thunkApi.rejectWithValue(error)
    }
})
//! en uzun yükleme süresi raporu
export const getLongestUploadDurationReport = createAsyncThunk("report/getLongestUploadDurationReport", async (currentPage , thunkApi) => {
    try{
        const {data} = await axiosInstance.get(`/Reports/GetLongestOffloadDurationReport?pagesize=10&page=${currentPage}`)
        
        return data
    }catch(error){
        return thunkApi.rejectWithValue(error)
    }
})
//! en uzun boşaltma süresi raporu
export const getLongestOffloadDurationReport = createAsyncThunk("report/getLongestOffloadDurationReport", async (currentPage , thunkApi) => {
    try{
        const {data} = await axiosInstance.get(`/Reports/GetLongestOffloadDurationReport?pagesize=10&page=${currentPage}`)
        
        return data
    }catch(error){
        return thunkApi.rejectWithValue(error)
    }
})



//! sevkiyat raporu excel indirme
export const getShipmentReportExcel = createAsyncThunk(
    "report/getShipmentReportExcel",
    async ({ startDate, endDate }, thunkApi) => {
        try {
            const formattedEndDate = endDate.includes("T")
                ? endDate
                : `${endDate}T23:59:59`

            const response = await axiosInstance.get(
                `/Reports/GetShipmentReportExcelV1?startDate=${encodeURIComponent(startDate)}&endDate=${encodeURIComponent(formattedEndDate)}`,
                {
                    responseType: "blob"
                }
            )

            const contentType = response.headers["content-type"]

            //! API hata durumunda blob yerine json dönebiliyor
            if (contentType && contentType.includes("application/json")) {
                const text = await response.data.text()
                const jsonData = JSON.parse(text)

                return thunkApi.rejectWithValue(
                    jsonData?.error?.message ||
                    jsonData?.message ||
                    "Sevkiyat raporu indirilemedi."
                )
            }

            let fileName = `SevkiyatRaporu_${startDate}_${endDate}.xlsx`

            const contentDisposition = response.headers["content-disposition"]

            if (contentDisposition) {
                const fileNameMatch = contentDisposition.match(/filename\*?=(?:UTF-8'')?["']?([^"';]+)/i)

                if (fileNameMatch?.[1]) {
                    fileName = decodeURIComponent(fileNameMatch[1])
                }
            }

            const blob = new Blob([response.data], {
                type: contentType || "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
            })

            const url = window.URL.createObjectURL(blob)
            const link = document.createElement("a")

            link.href = url
            link.setAttribute("download", fileName)

            document.body.appendChild(link)
            link.click()
            link.remove()

            window.URL.revokeObjectURL(url)

            return true
        } catch (error) {
            try {
                if (error?.response?.data instanceof Blob) {
                    const text = await error.response.data.text()
                    const jsonData = JSON.parse(text)

                    return thunkApi.rejectWithValue(
                        jsonData?.error?.message ||
                        jsonData?.message ||
                        "Sevkiyat raporu indirilemedi."
                    )
                }
            } catch {
                return thunkApi.rejectWithValue("Sevkiyat raporu indirilemedi.")
            }

            return thunkApi.rejectWithValue(
                error?.response?.data?.message ||
                error?.message ||
                "Sevkiyat raporu indirilemedi."
            )
        }
    }
)


const reportSlice = createSlice({
    name:"report",
    initialState,
    reducers: {

    },
    extraReducers: (builder) => {
        builder
        //!
        .addCase(getLoadRegistrationReport.pending, (state)=> {
            state.isLoadingGet = true
        })

        .addCase(getLoadRegistrationReport.fulfilled, (state, action)=> {
            state.yukKaydiRaporList = action.payload.$values
            state.isLoadingGet = false
        })

        .addCase(getLoadRegistrationReport.rejected, (state, action)=> {
            state.isErrorGet = true
        })
        //!
        .addCase(getAverageVehicleSupplyTimeReport.pending, (state)=> {
            state.isLoadingGet = true
        })

        .addCase(getAverageVehicleSupplyTimeReport.fulfilled, (state, action)=> {
            state.ortalamaAracTedarikRapor = action.payload
            state.isLoadingGet = false
        })

        .addCase(getAverageVehicleSupplyTimeReport.rejected, (state, action)=> {
            state.isErrorGet = true
        })
        //!
        .addCase(getArchivedLoadRecordsAndReasonReport.pending, (state)=> {
            state.isLoadingGet = true
        })

        .addCase(getArchivedLoadRecordsAndReasonReport.fulfilled, (state, action)=> {
            state.arsivYukGerekceRaporList = action.payload
            state.isLoadingGet = false
        })

        .addCase(getArchivedLoadRecordsAndReasonReport.rejected, (state, action)=> {
            state.isErrorGet = true
        })
        //!
        .addCase(getLoadingDurationReport.pending, (state)=> {
            state.isLoadingGet = true
        })

        .addCase(getLoadingDurationReport.fulfilled, (state, action)=> {
            state.loadingDurationReport = action.payload
            state.isLoadingGet = false
        })

        .addCase(getLoadingDurationReport.rejected, (state, action)=> {
            state.isErrorGet = true
        })
        //!
        .addCase(getUnloadingDurationReport.pending, (state)=> {
            state.isLoadingGet = true
        })

        .addCase(getUnloadingDurationReport.fulfilled, (state, action)=> {
            state.unloadingDurationReport = action.payload
            state.isLoadingGet = false
        })

        .addCase(getUnloadingDurationReport.rejected, (state, action)=> {
            state.isErrorGet = true
        })
        //!
        .addCase(getLongestUploadDurationReport.pending, (state)=> {
            state.isLoadingGet = true
        })

        .addCase(getLongestUploadDurationReport.fulfilled, (state, action)=> {
            state.longestLoadReport = action.payload.items.$values
            state.longestLoadReportCount = action.payload.count
            state.isLoadingGet = false
        })

        .addCase(getLongestUploadDurationReport.rejected, (state, action)=> {
            state.isErrorGet = true
        })
        //!
        .addCase(getLongestOffloadDurationReport.pending, (state)=> {
            state.isLoadingGet = true
        })

        .addCase(getLongestOffloadDurationReport.fulfilled, (state, action)=> {
            state.longestUnloadReport = action.payload.items.$values
            state.longestUnloadReportCount = action.payload.count
            state.isLoadingGet = false
        })

        .addCase(getLongestOffloadDurationReport.rejected, (state, action)=> {
            state.isErrorGet = true
        })




                .addCase(getShipmentReportExcel.pending, (state) => {
            state.isLoadingShipmentReportExcel = true
            state.isErrorShipmentReportExcel = ""
            state.shipmentReportExcelDownloaded = false
        })

        .addCase(getShipmentReportExcel.fulfilled, (state) => {
            state.isLoadingShipmentReportExcel = false
            state.isErrorShipmentReportExcel = ""
            state.shipmentReportExcelDownloaded = true
        })

        .addCase(getShipmentReportExcel.rejected, (state, action) => {
            state.isLoadingShipmentReportExcel = false
            state.isErrorShipmentReportExcel = action.payload || true
            state.shipmentReportExcelDownloaded = false
        })
        
    }
})

export const {} = reportSlice.actions
export default reportSlice.reducer